import React, { FC } from 'react';
import { Link } from 'react-router-dom';

import classNames from 'classnames';

import { EvSection, EvTitle } from '@evinced-private/ui-common';

import { formatTextToId } from '../../../helpers/IdFormatterHelper';
import { SummaryItem } from '../../../interfaces/SummaryItem';

import './SummaryPane.scss';

interface ISummaryPaneV2Props {
	title: string;
	items: SummaryItem[];
	sectionLabel?: string;
	labeledById?: string;
	className?: string;
	shouldHaveSkipLink?: boolean;
	renderActionButtons?: () => JSX.Element;
}

const SummaryPaneV2: FC<ISummaryPaneV2Props> = ({
	title,
	items,
	className,
	sectionLabel = '',
	labeledById = '',
	shouldHaveSkipLink = true,
	renderActionButtons
}: ISummaryPaneV2Props) => {
	const sectionTitleId = formatTextToId(title);

	const renderPaneContent = (value, label): JSX.Element => (
		<div className="summary-pane-content" aria-hidden="true">
			<div className="value">{value}</div>
			<div className="label">{label}</div>
		</div>
	);

	const renderSummaryItem = ({ label, value, link, isDashedBorder }: SummaryItem): JSX.Element => {
		return (
			<li
				className={classNames('summary-pane-item summary-pane-item-v2', {
					'is-dashed': isDashedBorder
				})}
				key={label}
				aria-label={`${value} ${label}`}
			>
				{link ? (
					<Link to={link} aria-label={`${label} details`}>
						{renderPaneContent(value, label)}
					</Link>
				) : (
					renderPaneContent(value, label)
				)}
			</li>
		);
	};
	return (
		<EvSection
			className={`summary-pane ${className}`}
			ariaLabel={sectionLabel}
			ariaLabelledby={labeledById}
			skipLinkId={shouldHaveSkipLink ? 'grouping-issues-into-components' : null}
		>
			<>
				<EvTitle titleText={title} className="chart-title" id={sectionTitleId} />
				{renderActionButtons?.()}

				<ul>{items.map(renderSummaryItem)}</ul>
			</>
		</EvSection>
	);
};

export { SummaryPaneV2 };
